// JWT Cookie helpers - mirrors JWT to cookie for Cloudflare worker access
// NOTE: HttpOnly cannot be set from client-side JavaScript (browser security restriction).
// This cookie is intentionally readable by JS since it's set client-side. The JWT is also
// stored in sessionStorage which has the same XSS exposure. If HttpOnly is required,
// the cookie must be set server-side via Set-Cookie response headers.

const JWT_COOKIE_NAME = 'vendor_session';

export function setJWTCookie(token: string): void {
  if (!token) return;

  // Remove "Bearer " prefix if present
  const cleanToken = token.replace(/^Bearer\s+/i, '');

  // Set cookie with security attributes
  // Expires in 3 days to match SessionDuration
  const maxAge = 60 * 60 * 24 * 3; // 3 days in seconds
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';

  document.cookie = `${JWT_COOKIE_NAME}=${cleanToken}; Path=/; Max-Age=${maxAge}; SameSite=Strict${secure}`;
}

export function clearJWTCookie(): void {
  document.cookie = `${JWT_COOKIE_NAME}=; Path=/; Max-Age=0; SameSite=Strict`;
}

